"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcIntervalForFilter = void 0;
const TimeInterval_1 = __importDefault(require("@opsbase/lib-time/TimeInterval"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
function calcIntervalForFilter(filter) {
    if (!filter)
        return TimeInterval_1.default.DAY;
    const { from, to } = filter;
    const intervalWeeks = (0, moment_timezone_1.default)(to).diff(from, 'week');
    const intervalDays = (0, moment_timezone_1.default)(to).diff(from, 'day');
    return intervalWeeks > 6
        ? TimeInterval_1.default.MONTH
        : intervalDays > 21
            ? TimeInterval_1.default.WEEK
            : TimeInterval_1.default.DAY;
}
exports.calcIntervalForFilter = calcIntervalForFilter;
